import logo from 'assets/img/icons/logo.png';
import Decrease_2 from 'assets/img/spot-illustrations/Decrease_2.jpg';
import Decrease_3 from 'assets/img/spot-illustrations/Decrease_3.jpg';
import { Feature } from 'data/landing/alternate-landing-data';
import { useAppContext } from 'providers/AppProvider';
import FeatureSection from './FeatureSection';
import consultations from 'assets/img/spot-illustrations/consultations.jpeg';
import frustration from 'assets/img/spot-illustrations/frustration.jpeg';

export const features: Feature[] = [
  {
    id: 1,
    title: 'MLAS: Kuwaits Intelligent Meal Logging System',
    description:
      'MLAS uses advanced AI to identify foods from a simple photo. Patients can log meals in seconds, and clinicians receive precise macronutrient data automatically. No manual input. No confusion. Just reliable, real-time dietary analysis.',
    lightImg: logo,
    darkImg: logo
  }
];

export const features1: Feature[] = [
  {
    id: 1,
    title: 'Faster, Smarter, Consultations.',
    description:
      "Patients don't see the nutritional data — dietitians do. MLAS ensures accurate interpretation, protects patients from misreading complex data, and empowers healthcare professionals to focus on outcomes, not manual logging.",
    // lightImg: Decrease_2,
    // darkImg: Decrease_2
    lightImg: consultations,
    darkImg: consultations
  },
  {
    id: 2,
    title: 'Less errors, Less Frustration.',
    description:
      'No more recall bias, just smarter nutrition logging and analysis.',
    // lightImg: Decrease_3,
    // darkImg: Decrease_3
    lightImg: frustration,
    darkImg: frustration
  }
];

const Features = () => {
  const { getThemeColor } = useAppContext();
  return (
    <>
      <section id="features" className="pt-0 pb-0">
        <div className="container-small px-lg-7 px-xxl-3">
          <div className="text-center mb-10 mb-md-5">
            <h2 className="mb-3 lh-base">
              What is <b style={{ color: getThemeColor('primary') }}>MLAS</b>?
            </h2>
            {/* <p className="mb-0">
              Focus only on functionalities for your digital products with
              Phoenix! Leave the UIs for us.
            </p>
            <div className="text-center mt-5">
              <Button
                variant="outline-primary"
                endIcon={
                  <FontAwesomeIcon icon={faAngleRight} transform="down-1" />
                }
              >
                See more
              </Button>
            </div> */}
          </div>
          {features.map((feature, index) => (
            <FeatureSection
              key={feature.id}
              feature={feature}
              isLast={index === features.length - 1}
            />
          ))}
        </div>
      </section>
      <section id="features" className="pt-0 pb-0">
        <div className="container-small px-lg-7 px-xxl-3">
          <div className="text-center mb-10 mb-md-5">
            <h2 className="mb-3 lh-base">Designed for Dietitians</h2>
            <p className="mb-0">Emphasizes Clinical Integrity</p>
          </div>
          {features1.map((feature, index) => (
            <FeatureSection
              key={feature.id}
              feature={feature}
              isLast={index === features.length - 1}
              imageFirst={index % 2 !== 0}
            />
          ))}
        </div>
      </section>
    </>
  );
};

export default Features;
